import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllDeaerators = async (page, size, searchString) => {
  const response = await api.get(`/${ENDPOINTS.DEAERATORS}`, {
    params: { page, size, search: searchString },
  });

  return response.data;
};